"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const englishTranslation = {
    removeGiftCardText: 'Remove gift card',
    editSectionButton: 'Edit Section',
};
exports.default = englishTranslation;
